export default __webpack_public_path__ + "static/media/avt-3.c03860ca.jpg";